module.exports = __webpack_public_path__ + "img/un.a2e14211.svg";